import { signalStore, withState, withMethods, patchState } from '@ngrx/signals';

// Define the state interface
interface loggedOutState {
  backgroundColor: string | null;
}

// Initial state
const initialState: loggedOutState = {
  backgroundColor: null,
};

export const LoggedOutStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    setBackgroundColor(color: string): void {
      patchState(store, { backgroundColor: color });
    },
    reset(): void {
      patchState(store, initialState);
    },
  })),
);
